import { Colors } from '../../theme'

export default {
  boxShadow: 'none',
  borderTop: `1px solid ${Colors.Palette.borderColor}`
}



// WEBPACK FOOTER //
// ./src/styles/cards/hcsa.js